import { Send, Bot, StopCircle } from "lucide-react";

interface ChatInputProps {
	inputValue: string;
	onInputChange: (value: string) => void;
	onSend: () => void;
	isStreaming: boolean;
	onStop: () => void;
	onOpenChat: () => void;
	hasMessages: boolean;
	chatOpen: boolean;
}

export default function ChatInput({
	inputValue,
	onInputChange,
	onSend,
	isStreaming,
	onStop,
	onOpenChat,
	hasMessages,
	chatOpen,
}: ChatInputProps) {
	return (
		<div className="absolute bottom-4 left-1/2 -translate-x-1/2 z-30 w-full max-w-xl px-4">
			<div className="flex gap-2 items-center bg-slate-800/90 backdrop-blur-xl border border-slate-700/50 rounded-2xl px-4 py-2 shadow-2xl">
				{hasMessages && !chatOpen && (
					<button
						onClick={onOpenChat}
						className="p-2 text-blue-400 hover:text-blue-300 rounded-lg hover:bg-blue-400/10 transition-all shrink-0"
						title="Show chat"
					>
						<Bot className="w-5 h-5" />
					</button>
				)}
				<input
					type="text"
					value={inputValue}
					onChange={(e) => onInputChange(e.target.value)}
					onKeyDown={(e) => e.key === "Enter" && !e.shiftKey && onSend()}
					placeholder="Ask about your knowledge graph..."
					disabled={isStreaming}
					className="flex-1 bg-transparent text-white placeholder-slate-500 focus:outline-none text-sm disabled:opacity-50 py-1"
				/>
				{isStreaming ? (
					<button
						onClick={onStop}
						className="p-2 bg-red-600/80 hover:bg-red-500 text-white rounded-xl transition-all shrink-0"
						title="Stop generating"
					>
						<StopCircle className="w-4 h-4" />
					</button>
				) : (
					<button
						onClick={onSend}
						disabled={!inputValue.trim()}
						className="p-2 bg-blue-600 hover:bg-blue-500 disabled:bg-slate-700 disabled:text-slate-500 text-white rounded-xl transition-all shrink-0"
						title="Send"
					>
						<Send className="w-4 h-4" />
					</button>
				)}
			</div>
			{isStreaming && (
				<div className="flex items-center justify-center gap-2 mt-2">
					<div className="flex gap-1">
						<span className="w-1.5 h-1.5 bg-blue-400 rounded-full animate-bounce [animation-delay:0ms]" />
						<span className="w-1.5 h-1.5 bg-blue-400 rounded-full animate-bounce [animation-delay:150ms]" />
						<span className="w-1.5 h-1.5 bg-blue-400 rounded-full animate-bounce [animation-delay:300ms]" />
					</div>
					<span className="text-xs text-blue-400/80">Generating...</span>
				</div>
			)}
		</div>
	);
}
